import { CSSObject } from "styled-components";
import { vfxTheme } from "../Theme/theme";

interface GeneralStyles {
  root: CSSObject;
  description: CSSObject;
  errorPageIcon: CSSObject;
  errorPageTitle: CSSObject;
}

const useGeneralStyles = (): GeneralStyles => {
  
  return {
    root: {
      flexGrow: 1,
      marginTop: 100,
      overflow: "hidden",
    },
    description: {
      marginTop: "8px",
    },
    errorPageIcon: {
        color: vfxTheme.palette.blues.b300,
      marginLeft: "80px",
      marginBottom: "15px",
      fontSize: 30,
    },
    errorPageTitle: {
      fontSize: "25px",
    },
  };
};

export default useGeneralStyles;
